import { Component, OnInit } from '@angular/core';
import { UserService } from '../shared/user.service';
import { HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {
  public userDetails: any;

  showTestMessage: any = environment.showTestMessage;

  constructor(private userService: UserService) { }
  
  ngOnInit() {
    
    this.userService.getUserClaims().subscribe((data: any) => {
      this.userDetails = data;

    },
    (err : HttpErrorResponse)=>{
      this.userDetails = null;
    });
  }

}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/menu/menu.component.ts